<template>
    <div>
        <TaskCreate
            v-model="showCreate"
        ></TaskCreate>
        <TaskUpdate
            v-model="editTask"
        ></TaskUpdate>

        <AccountTabs
            v-model="currentTab"
            :tabs="tabsWithCount"
        />

        <div class="content">
            <Button
                outline
                v-if="currentTab === 'incoming'"
                class="btn btn-create"
                @click="showCreate = true"
            >Новая задача</Button>
            <div
                class="empty"
                v-if="!items.length"
            >
                {{ emptyText }}
            </div>
            <TaskList
                v-else
                :items="currentItems"
                @click="edit"
            />
            <ShowMoreButton
                v-if="items.length > currentLimit"
                @click="currentLimit = items.length"
            ></ShowMoreButton>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import Button from '../../../UI/Button';
import TaskList from './tasks/List';
import TaskCreate from './tasks/Create';
import TaskUpdate from './tasks/Update';
import ShowMoreButton from './UI/ShowMoreButton';
import AccountTabs from '../../../UI/AccountTabs';

const actions = [
    'loadTasks',
];

const defaultLimit = 6;

export default {
    name: 'Tasks',
    components: {
        Button,
        TaskList,
        TaskCreate,
        TaskUpdate,
        ShowMoreButton,
        AccountTabs,
    },
    data: () => ({
        loading: true,
        currentTab: 'incoming',
        currentLimit: 6,
        tabs: [
            { label: 'Предстоящие', color: 'blue', key: 'incoming', empty: 'Нет предстоящих задач' },
            { label: 'Пропущенные', color: 'red', key: 'missed', empty: 'Нет пропущенных задач' },
            { label: 'Выполненые', color: 'grey', key: 'completed', empty: 'Нет выполненных задач' },
        ],
        showCreate: false,
        editTask: null,
    }),
    computed: {
        currentTabItem() {
            return this.tabs.find(v => v.key === this.currentTab);
        },
        tabsWithCount() {
            return this.tabs
                .map(v => ({
                    ...v,
                    count: this.$store.getters[`mentoring/tasks/${v.key}Tasks`].length,
                }));
        },
        items() {
            let name = `${this.currentTabItem.key}Tasks`;
            return this.$store.getters[`mentoring/tasks/${name}`];
        },
        currentItems() {
            return this.items.slice(0, this.currentLimit || this.items.length);
        },
        emptyText() {
            return this.currentTabItem.empty;
        },
    },
    methods: {
        ...mapActions('mentoring/tasks', actions),
        edit(i) {
            this.editTask = this.items[i];
        },
    },
    watch: {
        currentTab() {
            this.currentLimit = defaultLimit;
        },
    },
    mounted() {
        this.loading = true;
        this.loadTasks();
        this.loading = false;
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../styles/rem';

    .tabs {
        background-color: #fff;
        height: 2rem;
        display: flex;
        user-select: none;
        cursor: pointer;
        margin-bottom: 1.2rem;

        * {
            font-size: .8rem;
            font-weight: 500;
        }
    }

    .tab {
        padding: 0 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: .12rem solid #BAC5CB;
        position: relative;

        &.active {
            color: #4663AB;
            border-color: #4663AB;
        }
    }

    .empty {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #98A0A9;
        font-size: rem(15);
        line-height: rem(22);
        font-weight: 600;
    }

    @include on-mobile {
        .tabs {
            height: auto;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            margin-bottom: mrem(24);

            * {
                font-size: mrem(14);
            }
        }

        .tab {
            width: 100%;
            height: mrem(40);
            padding: 0;
            margin-bottom: mrem(4);
            border: mrem(1) solid #D2D5D9;
            border-radius: mrem(4);
            color: #4663AB;
            background-color: #fff;

            &.active {
                color: #fff;
                background-color: #4663AB;
            }
        }

        .empty {
            font-size: mrem(14);
            line-height: mrem(17);
            font-weight: 500;
            margin: 0;
        }
    }

    .show-more {
        cursor: pointer;
        display: inline-block;
        font-style: normal;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #4663AB;
        padding-bottom: 1px;
        border-bottom: 1px solid #4663AB;
        margin-top: rem(24);
    }

    .btn-create {
        margin-bottom: rem(26);
        padding: 0 rem(24);
        @include on-mobile{
            width: 100%;
            margin-bottom: mrem(36);
        }
    }
</style>